import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import AddNewTask from "@/modules/tasks/components/add-task";
import { getAddTaskButtonSx } from "@/modules/tasks/components/tasks-view/get-add-button-sx";
import { useTheme } from "@mui/material";
import { useContext, useMemo } from "react";

const AddLeadTask = () => {
  const { lead } = useContext(LeadPageContext);

  const theme = useTheme();
  const { isMobile } = useScreenSize();

  const addTaskButtonSx = useMemo(
    () => getAddTaskButtonSx(theme, isMobile),
    [theme, isMobile],
  );

  return (
    <AddNewTask
      disableRipple
      disableAssignee
      disableLead
      prefilledAssignee={
        lead?.data?.lead?.user
          ? {
              uid: lead.data.lead.user.id,
              name: lead.data.lead.user.name,
            }
          : undefined
      }
      prefilledLead={
        lead?.data
          ? {
              uid: lead.data.uid,
              nanoId: lead.data.nanoId,
              name: lead.data.lead.name,
            }
          : undefined
      }
      addTaskButtonSX={addTaskButtonSx}
    />
  );
};

export default AddLeadTask;
